'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

(function(GameVendor2) {
  GameVendor2["NETENT"] = "Netent";
  GameVendor2["EVOLUTION"] = "Evolution";
  GameVendor2["PLAY_N_GO"] = "Play N Go";
  GameVendor2["YGGDRASIL"] = "Yggdrasil";
  GameVendor2["BETSOFT"] = "BetSoft";
  GameVendor2["IGT"] = "IGT";
  GameVendor2["NYX_GAMING"] = "NYX Gaming";
  GameVendor2["SG_WMS"] = "SG Wms";
  GameVendor2["QUICKSPIN"] = "Quickspin";
  GameVendor2["MICROGAMING"] = "Microgaming";
  GameVendor2["RED_TIGER"] = "Red Tiger";
  GameVendor2["GREEN_TUBE"] = "Green Tube";
  GameVendor2["SCIENTIFIC_GAMES"] = "Scientific Games";
  GameVendor2["REEL54"] = "Reel54";
  GameVendor2["GENII"] = "Genii";
  GameVendor2["EDICT"] = "Edict";
  GameVendor2["SPIGO"] = "Spigo";
  GameVendor2["ELK"] = "Elk";
  GameVendor2["BIG_TIME_GAMING"] = "Big Time Gaming";
  GameVendor2["PRAGMATIC_PLAY"] = "Pragmatic Play";
  GameVendor2["THUNDERKICK"] = "Thunderkick";
  GameVendor2["PUSH_GAMING"] = "Push Gaming";
  GameVendor2["PARIPLAY"] = "Pariplay";
  GameVendor2["SPIN"] = "Spin";
  GameVendor2["SLINGO"] = "Slingo";
  GameVendor2["SOFTWEAVE_WINAFAR"] = "Softweave Winafar";
  GameVendor2["AUTHENTIC_GAMES"] = "Authentic Games";
  GameVendor2["NO_LIMIT_CITY"] = "Nolimit City";
  GameVendor2["GIG_GAMES"] = "GiG Games";
  GameVendor2["EVERI"] = "Everi";
  GameVendor2["ISOFTBET"] = "iSoftBet";
  GameVendor2["RELAX_GAMING"] = "Relax Gaming";
  GameVendor2["ORYX_GAMING"] = "Oryx Gaming";
  GameVendor2["BLUEPRINT"] = "Blueprint";
})(exports.GameVendor || (exports.GameVendor = {}));
